import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ToolPage from './pages/ToolPage';
import { validateToken } from './services/api';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = async () => {
    try {
      // Step 1: Check URL for token (from WordPress dashboard redirect)
      const params = new URLSearchParams(window.location.search);
      let token = params.get('token');

      // Step 2: If no token in URL, check localStorage
      if (!token) {
        token = localStorage.getItem('authToken');
      }

      // Step 3: If we have a token, validate it
      if (token) {
        console.log('🔐 Found token, validating...');
        const validation = await validateToken(token);
        
        if (validation.success && validation.user) {
          console.log('✅ Authentication successful:', validation.user);
          
          // Save token to localStorage for persistence
          localStorage.setItem('authToken', token);
          localStorage.setItem('user', JSON.stringify(validation.user));
          
          // Clean up URL (remove token from URL bar)
          window.history.replaceState({}, document.title, window.location.pathname);
          
          setUser(validation.user);
        } else {
          throw new Error('Token validation failed');
        }
      } else {
        throw new Error('No token found');
      }
    } catch (error) {
      console.error('❌ Auth error:', error.message);
      setError('Authentication failed. Please access from ContentSERP dashboard.');
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    
    // Redirect back to WordPress dashboard
    window.location.href = 'https://contentserp.in/dashboard';
  };

  // Loading screen
  if (loading) {
    return (
      <div className="auth-loading">
        <div className="spinner"></div>
        <p>🔐 Authenticating...</p>
      </div>
    );
  }

  // Error screen
  if (error || !user) {
    return (
      <div className="auth-error">
        <div className="error-box">
          <h2>❌ Authentication Failed</h2>
          <p>{error || 'Please access this tool from your ContentSERP dashboard.'}</p>
          <a href="https://contentserp.in/dashboard" className="btn-primary">
            ← Back to ContentSERP Dashboard
          </a>
        </div>
      </div>
    );
  }

  // Authenticated - show tool
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/*"
          element={<ToolPage user={user} onLogout={handleLogout} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
